import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DcpParagraphComponent} from './dcp-paragraph/dcp-paragraph.component';
import {ConfigModule} from '@spartacus/core';
import {DefaultComponentHandler, SupplementHashAnchorsModule} from '@spartacus/storefront';
import {DcpDefaultComponentHandler} from './dcp-default-component-handler/dcp-default-component-handler.service';

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CMSParagraphComponent: {
          component: DcpParagraphComponent,
        },
        CMSTabParagraphComponent: {
          component: DcpParagraphComponent,
        },
      },
    }),
    SupplementHashAnchorsModule,
    DcpParagraphComponent,
  ],
  providers: [{provide: DefaultComponentHandler, useExisting: DcpDefaultComponentHandler}],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FixesModule {}
